<template>
    <div class="container-fluid forms-search-container">
        <div class="row">
            <div class="col-12" />
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <form
                            action=""
                            @submit.prevent="searchFormSubmit()"
                            class="form-inline"
                        >
                            <div class="input-group col-12 col-md-2">
                                <input
                                    type="search"
                                    name="keyword"
                                    id="keyword"
                                    placeholder="Search..."
                                    v-model.lazy="keyword"
                                    class="form-control"
                                >
                            </div>
                            <div class="input-group col-12 col-md-2">
                                <user-select
                                    v-model.lazy="actionedBy"
                                    :engineers="false"
                                    :autoselect="false"
                                    enable-null
                                />
                            </div>
                            <div class="input-group col-12 col-md-4">
                                <div class="form-check form-check-inline">
                                    <input
                                        type="checkbox"
                                        name="hide_invoiced"
                                        id="hide_invoiced"
                                        v-model.lazy="hide_invoiced"
                                        class="form-control"
                                    >&nbsp;
                                    <label for="hide_invoiced">Hide Invoiced</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        type="checkbox"
                                        name="with_customer_forms"
                                        id="with_customer_forms"
                                        v-model.lazy="with_customer_forms"
                                        class="form-control"
                                    >&nbsp;
                                    <label for="with_customer_forms">Group by customer</label>
                                </div>
                            </div>
                            <button class="btn btn-primary mr-sm-2">
                                <i class="fa fa-search" /> Search
                            </button>
                            <button
                                class="btn btn-success mr-sm-2"
                                type="button"
                                @click.prevent="newForm()"
                            >
                                <i class="fa fa-plus" /> New Form
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <table
                            class="table"
                            v-if="forms.length"
                            :class="{disabled: loading}"
                        >
                            <thead>
                                <tr>
                                    <th>Doc No.</th>
                                    <th>Type</th>
                                    <th>Customer & Site</th>
                                    <th>Engineer</th>
                                    <th>Status</th>
                                    <th>Notes</th>
                                    <th>Created</th>
                                    <th>Action By</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <invoiceable-form-row
                                    v-for="form in forms"
                                    :key="form.id"
                                    :form="form"
                                />
                            </tbody>
                        </table>
                        <pagination
                            :page="page"
                            :last-page="lastPage"
                            @pageChange="pageChange"
                        />
                        <span
                            class="pagination-stats"
                            v-if="total > 0"
                        >Showing {{ from }} - {{ to }} out of {{ total }}</span>
                        <span v-if="!forms.length && !loading">No forms to show</span>
                        <i
                            class="fa fa-spinner fa-pulse mb-2 mr-sm-2"
                            v-if="loading"
                        />
                    </div>
                </div>
            </div>
        </div>
        <new-form-modal ref="newFormModal" />
    </div>
</template>

<script>
import FormService from "../../services/FormService";
import NewFormModal from "../forms/NewFormModal.vue";
import AuthService from "../../services/AuthService";
import Pagination from "../PaginationComponent.vue";
import UserSelect from '../UserSelectComponent.vue';
import InvoiceableFormRow from './InvoiceableFormRow.vue';

export default {
    components: {
        'new-form-modal': NewFormModal,
        pagination: Pagination,
        UserSelect,
        InvoiceableFormRow,
    },
    data: function () {
        return {
            forms: [],
            loading: false,
            token: null,
            lastPage: 1,
            perPage: 50,
            from: 1,
            to: 1,
            total: 0,
            types: ['handover', 'fire_ex_service', 'recommendations', 'zf_form', 'fire_training'],
        };
    },
    computed: {
        keyword: {
            get() {
                return this.$route.query.keyword || '';
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    keyword: value,
                }});
            }
        },
        actionedBy: {
            get() {
                return this.$route.query.actionedBy;
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    actionedBy: value,
                }});
            }
        },
        hide_invoiced: {
            get() {
                let value = this.$route.query.hide_invoiced;
                if (typeof value === 'undefined') {
                    value = true;
                }
                return value;
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    hide_invoiced: value,
                }});
            }
        },
        with_customer_forms: {
            get() {
                const value = this.$route.query.with_customer_forms;
                return value === true || value === 'true';
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    with_customer_forms: value,
                }});
            }
        },
        page: {
            get() {
                return parseInt(this.$route.query.page || '1');
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    page: value,
                }});
            }
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.searchForms();
            },
        }
    },
    mounted: function () {
    },
    methods: {
        searchFormSubmit: function() {
            this.page = 1;
        },
        searchForms: function () {
            this.loading = true;
            FormService.search({
                keyword: this.keyword,
                hide_invoiced: this.hide_invoiced,
                page: this.page,
                types: this.types,
                invoiced_by_id: this.actionedBy,
                order_dir: 'asc',
                with_customer_forms: this.with_customer_forms,
            }).then(
                res => {
                    this.forms = res.data.data;
                    for (let form of this.forms) {
                        if (form.job !== null && form.invoiced_at) {
                            form.invoiced_at = window.moment(form.invoiced_at);
                        }
                        form.created_at = window.moment(form.created_at);
                        form.sent_at = form.sent_at ? window.moment(form.sent_at) : null;
                    }
                    this.lastPage = res.data.last_page;
                    this.perPage = res.data.per_page;
                    this.total = res.data.total;
                    this.from = res.data.from;
                    this.to = res.data.to;
                    this.loading = false;
                },
                err => {
                    this.loading = false;
                    alert("Error: Could not load forms");
                    console.error(err);
                }
            );
        },
        pageChange: function(page) {
            this.page = page;
        },
        newForm: function () {
            this.$refs.newFormModal.show();
        },
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/office/InvoiceableFormsComponent.vue